<div class="position-fxd-top">
  <header>
    <div
      class="col-lg-12 mb-3 d-flex justify-content-between p-2 globalborder-btm-header">
      <div class="col-lg-4 d-flex align-items-center search-input">
        <span class="p-input-icon-right w-100-size searchbtn">
          <p-inputgroup>
            <p-inputgroup-addon>
              <i class="pi pi-search"></i>
            </p-inputgroup-addon>
            <input
              pInputText
              placeholder="Keyword"
              (keydown.enter)="onSubmit()"
              [(ngModel)]="searchedText" />
            <p-button label="Search" (click)="onSubmit()" />
          </p-inputgroup>
        </span>
      </div>
      <div class="col-auto d-flex align-items-center gap-3">
        <div class="col-auto d-flex gap-3">
          <div class="col-auto"><i class="pi pi-list-check"></i></div>
          <div class="col-auto">
            <p-popover
              #notificationPopover
              [dismissable]="true"
              styleClass="notificationPopUp">
              <ng-template #content>
                <div class="notification-list">
                  <ul class="m-0 p-0">
                    <li *ngFor="let item of notificationList">
                      <a
                        role="button"
                        (click)="
                          redirectAndMarkReadNotification(item.notificationId)
                        ">
                        <span
                          class="col-lg-12 d-flex justify-content-center align-items-center gap-2 globalborder-btm-header pb-1 mb-1">
                          <span class="col-lg-10">
                            <h3
                              *ngIf="
                                item.moduleName &&
                                item.moduleName === 'TaskManagement'
                              "
                              class="m-0">
                              Task Management |
                              {{
                                item.moduleId === "0"
                                  ? "Reminder"
                                  : getPaddedTaskId(item.moduleId)
                              }}
                            </h3>
                            <h3
                              *ngIf="
                                item.moduleName &&
                                item.moduleName === 'ProductionWorkflow'
                              "
                              class="m-0">
                              Production Workflow | #{{
                                getPaddedTaskId(item.moduleId)
                              }}
                            </h3>
                            <h2
                              *ngIf="
                                item.moduleName &&
                                item.moduleName !== 'TaskManagement' &&
                                item.moduleName !== 'ProductionWorkflow'
                              ">
                              ChatBox | {{ item.moduleName }}
                            </h2>
                            <span class="d-flex flex-row">
                              <span
                                class="notification-text"
                                [innerHtml]="
                                  formatMessage(item.message)
                                "></span>
                            </span>
                          </span>
                          <span class="col-lg-1">
                            <span
                              class="rounded-circle cir-color d-flex justify-content-center align-items-center"
                              >{{ item.createdBy | nameInitials }}</span
                            >
                          </span>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
                <span class="fx-notification-bar">
                  <a class="link" (click)="showNotificationHistoryPopUp()"
                    >Notification History</a
                  >
                </span>
              </ng-template>
            </p-popover>
            <a class="nav-link" (click)="notificationPopover.toggle($event)">
              <p-overlay-badge
                [value]="notificationCount"
                severity="danger"
                class="inline-flex"
                badgeSize="small">
                <i class="pi pi-bell"></i>
              </p-overlay-badge>
            </a>
          </div>
          <div class="col-auto themeswitch px-2">
            <p-popover
              #opMobileApp
              [dismissable]="false"
              styleClass="mobilePopUp">
              <ng-template #content>
                <div class="row d-flex align-items-center">
                  <div class="col-auto">
                    <img
                      src="../../../assets/images/waving-hand.gif"
                      alt="loading..."
                      class="gifSetting" />
                  </div>
                  <div class="col-auto">
                    <h2 class="mb-0">
                      <strong>Hello, Mobile App</strong>
                    </h2>
                    <a class="link mb-1" (click)="redirectToSalesAppPage()"
                      >QR Code</a
                    >

                    <div class="col-lg-12 mt-1">
                      <p-button
                        label="Don't show this again"
                        (click)="setHideMobilePopupDisplayValue()" />
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-popover>
            <button
              type="button"
              #displayButton
              (click)="opMobileApp.show($event, actualTarget)"
              style="display: none"></button>

            <a
              class="nav-link text-center"
              (click)="redirectToSalesAppPage()"
              #actualTarget
              ><i class="pi pi-mobile"></i
            ></a>
          </div>
          <div class="col-auto border-start border-end px-2 themeswitch">
            <p-button
              type="button"
              (onClick)="toggleDarkMode()"
              [rounded]="true"
              [icon]="isDarkTheme() ? 'pi pi-moon' : 'pi pi-sun'"
              severity="secondary" />
          </div>
        </div>
        <div
          class="col-auto d-flex gap-3 align-items-center"
          (click)="menu.toggle($event)">
          <div class="col-auto profile-icon">
            <p-avatar [image]="profileImage" shape="circle" />
          </div>
          <div class="col-auto flex-column d-flex lh-1 account-text">
            <span class="secondary-text">Welcome Back</span>
            <span class="primery-text">{{ user.name ?? "" }} </span>
          </div>
          <div class="col-auto">
            <i class="pi pi-angle-down"></i>
          </div>
        </div>
        <p-menu appendTo="body" #menu [model]="menuItems" [popup]="true" />
      </div>
    </div>
  </header>
  <jni-header-tags *ngIf="showHeaderTags()"></jni-header-tags>
</div>
<p-dialog
  [closable]="true"
  [(visible)]="notificationHistoryDialog"
  [modal]="true"
  [style]="{ width: '50vw', height: '50vh', padding: '20px' }"
  [draggable]="false"
  [resizable]="false"
  [position]="'center'"
  styleClass="pop-pd">
  <ng-template pTemplate="header">
    <div class="header-modal d-flex gap-3">
      <h2 class="me-2">Notification List</h2>
      <div
        class="lds-ring inline me-auto ms-2"
        *ngIf="showNotificataionSmallLoader">
        <jni-spinner />
      </div>
    </div>
  </ng-template>
  <div class="p-fluid p-dir-col p-p-3 mt-1 rm-maker">
    <ul class="notifications">
      <li
        *ngFor="let item of notificationHistoryList"
        class="rm-maker globalborder-btm-header">
        <a
          class="dropdown-item p-2"
          role="button"
          (click)="
            item.moduleName === 'TaskManagement'
              ? redirecttoTaskSummary(item.moduleId)
              : getNotificationProjectDetails(item.notificationId)
          ">
          <span
            class="col-lg-12 d-flex justify-content-between align-items-center gap-2">
            <span class="col-lg-10">
              <h3 *ngIf="item.moduleName === 'TaskManagement'" class="fw-bold">
                Task Management |
                {{
                  item.moduleId === "0"
                    ? "Reminder"
                    : getPaddedTaskId(item.moduleId)
                }}
              </h3>
              <h2 *ngIf="item.moduleName !== 'TaskManagement'">
                ChatBox | {{ item.moduleName }}
              </h2>
              <span class="d-flex flex-row">
                <span
                  class="notification-text fix-text"
                  [innerHtml]="formatMessage(item.message)"></span>
              </span>
            </span>
            <span class="col-lg-1">
              <span
                class="rounded-circle cir-color d-flex justify-content-center align-items-center"
                >{{ item.createdBy | nameInitials }}</span
              >
            </span>
          </span>
        </a>
      </li>
    </ul>
  </div>
</p-dialog>
